<template>
  <div>
    <p
      v-if="activeType === 'push'"
      class="cm-constructor-page__description"
    >
      {{ $t("campaign.firstHeaderPushErrors") }}
      <br>
      {{ $t("campaign.secondHeaderPushErrors") }}
    </p>
    <div
      :class="[
        'section-statistics__tab',
        { 'section-statistics__row--long-table-mode': longTablePart },
      ]"
    >
      <CirclePart
        v-if="!longTablePart"
        :isLoading="isLoadingErrorsTop"
        :isError="isErrorsTop"
        :value="valueErrorsTop"
        :errors="errors"
      />
      <TablePart
        :isLoading="isLoading"
        :isError="isError"
        :value="value"
        :activeType="activeType"
      />
    </div>
  </div>
</template>

<script>
import tabs_mixin from "@/components/statistics/stats/tabs/tabs_mixin";

import CirclePart from "./CirclePart.vue";
import TablePart from "./TablePart.vue";
import { mapState } from "vuex";

export default {
  name: "PushErrors",

  components: {
    TablePart,
    CirclePart,
  },

  mixins: [tabs_mixin],

  data() {
    return {
      errors: {
        400: this.$t("campaign.pushErrors.400"),
        404: this.$t("campaign.pushErrors.404"),
        403: this.$t("campaign.pushErrors.403"),
        429: this.$t("campaign.pushErrors.429"),
        503: this.$t("campaign.pushErrors.503"),
        500: this.$t("campaign.pushErrors.500"),
        401: this.$t("campaign.pushErrors.401"),
      },
    };
  },

  computed: {
    ...mapState({
      activeType: (state) => state.stat.activeType,
    }),
    value() {
      switch (this.activeType) {
      case "sms":
        return this.$store.getters.statErrorsSms &&
            this.$store.getters.statErrorsSms.records
          ? this.$store.getters.statErrorsSms.records
          : [];
      case "push":
        return this.$store.getters.statErrorsPush &&
            this.$store.getters.statErrorsPush.records
          ? this.$store.getters.statErrorsPush.records
          : [];
      case "webpush":
        return this.$store.getters.statErrorsWebpush &&
            this.$store.getters.statErrorsWebpush.records
          ? this.$store.getters.statErrorsWebpush.records
          : [];
      case "notification":
        return this.$store.getters.statErrorsNotification &&
            this.$store.getters.statErrorsNotification.records
          ? this.$store.getters.statErrorsNotification.records
          : [];
      default:
        return [];
      }
    },
    isLoading() {
      return this.$store.state.stat.loadings.errors;
    },
    isError() {
      return this.$store.state.stat.errors.errors;
    },
    valueErrorsTop() {
      return this.$store.getters.statErrorsTop[this.activeType];
    },
    isLoadingErrorsTop() {
      return this.$store.state.stat.loadings.errorsTop;
    },
    isErrorsTop() {
      return this.$store.state.stat.errors.errorsTop;
    },
  },
};
</script>

<style lang="scss">
.email-statistics--errors-donut-card {
  .cm-donut-card {
    padding: 0 20px;
  }
}
.promo-statistics--push {
  .cm-stat-table .bold {
    font-weight: 600;
    max-width: 400px;
    white-space: break-spaces;
  }
}
</style>

<style lang="scss" scoped>
.mr20 {
  margin-bottom: 20px;
  width: 260px !important;
}
.cm-constructor-page__description {
  margin-top: 0;
}
</style>